import {
  MultiplexPanelApproval,
  MultiplexPanelApprovalRequest,
  MultiplexPanelAssociationRequest,
  MultiplexPanelAssociationResponse,
  MultiplexPanelRevision,
  MultiplexPanelSaveRequest,
  MultiplexPanelsResponse,
} from 'interfaces/multiplexPanels';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
import { CasesParams } from 'utils/useCasesParams/types';

export const getMultiplexPanelsQueryKey = (casesParams: CasesParams) => ['multiplex_panels', casesParams];

export const getMultiplexPanels = (casesParams: CasesParams, signal?: AbortSignal) =>
  apiRequestHandlerPromise<MultiplexPanelsResponse>({
    url: 'multiplex_markers/panels.get',
    method: 'POST',
    signal,
    data: JSON.stringify(casesParams),
  });

export const saveMultiplexPanel = (studyId: string, request: MultiplexPanelSaveRequest) =>
  apiRequestHandlerPromise<MultiplexPanelRevision>({
    url: `studies/${studyId}/multiplex_panels.execute`,
    method: 'POST',
    data: JSON.stringify(request),
  });

export const recordMultiplexPanelApproval = (studyId: string, request: MultiplexPanelApprovalRequest) =>
  apiRequestHandlerPromise<MultiplexPanelApproval>({
    url: `studies/${studyId}/multiplex_panel_approvals.execute`,
    method: 'POST',
    data: JSON.stringify(request),
  });

export const associateMultiplexPanel = (studyId: string, request: MultiplexPanelAssociationRequest) =>
  apiRequestHandlerPromise<MultiplexPanelAssociationResponse>({
    url: `studies/${studyId}/multiplex_panel_members.execute`,
    method: 'POST',
    data: JSON.stringify(request),
  });
